var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSprout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9592 7.71667C12.8435 6.41905 12.4417 4.68874 11.2162 3.50393C9.72218 2.0595 7.38883 1.79807 6.05044 1.77845C5.43942 1.76949 4.96761 2.22533 4.97668 2.81587C4.99652 4.10939 5.26624 6.36461 6.76028 7.80905C7.95004 8.95931 9.67205 9.35936 11 9.48451V22.0002C11 22.5525 11.4477 23.0002 12 23.0002C12.5523 23.0002 13 22.5525 13 22.0002V15.701C13.1792 15.8183 13.3989 15.8847 13.6396 15.8811C15.0204 15.8609 17.4277 15.5912 18.9691 14.101C20.5105 12.6107 20.7887 10.2841 20.8092 8.94954C20.8185 8.34028 20.3318 7.87001 19.7014 7.87924C18.3206 7.89948 15.9133 8.1692 14.3719 9.65941C13.7057 10.3035 13.2755 11.1039 13 11.9128V8.0002C13 7.90172 12.9858 7.80656 12.9592 7.71667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprout);
export default __webpack_public_path__ + "static/media/sprout.a30d7c5f85f1b7fd20ad90608d1e3495.svg";
export { ForwardRef as ReactComponent };